export const MANY_COLLECTIONS_LIMIT = 9;
